import React, { useState } from "react";

import getDispensariesV3 from "@/api/requests/consumerApi/getDispensariesV3";
import { getUserLocationData } from "@/api/requests/getUserLocation";
import { DispensaryV3 } from "@/custom-types/DispensariesV3";
import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import { useEventTracker } from "@/hooks/useEventTracker";
import useOnComponentInView from "@/hooks/useOnComponentInView";
import { useSelector } from "@/redux/hooks";
import { getCoordinates } from "@/redux/selectors/location";
import { getUserId } from "@/redux/selectors/user";

import DispensariesCarouselView from "@/components/DispensariesCarouselView";

const MAX_DISPENSARY_TAKE = 7;
type Props = {
  title: string;
  linkText: string;
  page: string;
  changeLocation?: boolean;
  link: string;
  trackCardImpression: (
    slot: number,
    dispensary: DispensaryV3,
    carouselType: string,
  ) => void;
};
export const DeliveryRetailerCarouselContainer = ({
  title,
  linkText,
  changeLocation,
  link,
  trackCardImpression,
  page,
}: Props) => {
  const [dispensaries, setDispensaries] = useState<
    DispensaryV3[] | Record<string, never>[]
  >([{}, {}, {}, {}]);

  const coordinates = useSelector(getCoordinates);
  const countryCode = useDomainCountryCode();
  const userId = useSelector(getUserId);
  const { publishEvent } = useEventTracker();

  const getData = async () => {
    publishEvent({
      action: "impression",
      category: "Dispensaries Carousel",
      label: "Homepage Delivery Carousel",
      nonInteractionEvent: true,
    });

    const location = await getUserLocationData(countryCode);
    const coords = location?.coordinates
      ? {
          lat: location.coordinates.latitude,
          lon: location.coordinates.longitude,
        }
      : coordinates;

    const { stores, sponsoredStores } = await getDispensariesV3({
      ...coords,
      deliversToPoint: true,
      flags: ["delivery", "dispensary", countryCode],
      merchUnitName: "delivery-platinum-placement",
      sort: "default",
      take: MAX_DISPENSARY_TAKE,
    });

    sponsoredStores.forEach((s) => (s.isAd = true));

    const combined = [...sponsoredStores, ...stores].slice(
      0,
      MAX_DISPENSARY_TAKE,
    );
    setDispensaries(combined);
  };

  const [ref] = useOnComponentInView(getData, { freezeOnceVisible: true });

  if (dispensaries.length === 0 && !dispensaries.some((d) => d.name)) {
    return null;
  }

  return (
    <div ref={ref}>
      <DispensariesCarouselView
        dispensaries={dispensaries}
        countryCode={countryCode}
        title={title}
        linkText={linkText}
        link={link}
        userId={userId}
        changeLocation={changeLocation}
        trackCardImpression={trackCardImpression}
        page={page}
      />
    </div>
  );
};
export default DeliveryRetailerCarouselContainer;
